import { stateful } from '@adornis/functional-lit/stateful.js';
import { useQuery, type QueryState } from '@adornis/functional-lit/use-query.js';
import { globalLanguageSubject } from '@adornis/translation-core/client/languageSubject.js';
import { Language } from '@adornis/translation-core/languages.js';
import { html } from 'lit';

export const LanguageToggle = stateful(() => {
  const languageObs = globalLanguageSubject.asObservable();
  const language: QueryState<Language> = useQuery(() => languageObs, [languageObs]);
  // const lang = useObservable(() => globalLanguageSubject, []);
  // const isDE = lang === Language.GERMAN;
  return html`
    <button
      class="btn btn-outline join-item"
      @click=${() =>
        globalLanguageSubject.next(language.value === Language.GERMAN ? Language.ENGLISH : Language.GERMAN)}
    >
      <x-text class="tracking-wide">${language.value?.toLocaleUpperCase()}</x-text>
    </button>
  `;
});
